import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Settings as SettingsIcon,
  Add as AddIcon,
  List as ListIcon,
  AccountCircle as AccountCircleIcon,
  BarChart as BarChartIcon,
  LocalHospital as LocalHospitalIcon, // Adicionado para representar UBS
  ListAlt as ListAltIcon,
  LockReset as LockResetIcon
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorElConfig, setAnchorElConfig] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const username = localStorage.getItem("nome");
  const role = localStorage.getItem("role");

  // Verifica se a URL tem o parâmetro "user"
  const isUserParamPresent = new URLSearchParams(location.search).has("user");

  const handleLogout = () => {
    const pwaInstallDismissed = localStorage.getItem("pwaInstallDismissed");
    localStorage.clear();

    if (pwaInstallDismissed) {
      localStorage.setItem("pwaInstallDismissed", pwaInstallDismissed);
    }

    alert("Você foi deslogado com sucesso!");
    localStorage.removeItem("loginAttempts");
    navigate("/");
  };

  const handleHomeNavigation = () => {
    if (role === "ROLE_SECRETARIA") {
      navigate("/solicitacoes/PENDENTE");
    } else if (role === "ROLE_PSF") {
      navigate("/home_psf");
    } else {
      navigate("/home");
    }
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenConfigMenu = (event) => {
    setAnchorElConfig(event.currentTarget);
  };

  const handleCloseMenus = () => {
    setAnchorElUser(null);
    setAnchorElConfig(null);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const mobileMenu = (
    <Drawer anchor="left" open={isMobileMenuOpen} onClose={toggleMobileMenu} role="navigation" 
    aria-label="Menu de navegação móvel">
      <List>
        <ListItem
          button
          onClick={handleHomeNavigation}
          role="menuitem"
          aria-label="Ir para Home"
          sx={{
            transition:
              "background 0.3s ease-in-out, transform 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.07)",
              transform: "scale(1.05)",
            },
          }}
        >
          <ListItemIcon>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
        {role === "ROLE_SECRETARIA" && (
          <>
            <ListItem
              button
              onClick={() => {
                navigate("/home");
                toggleMobileMenu();
              }}
              sx={{
                transition: "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.07)",
                  transform: "scale(1.05)",
                },
              }}
            >
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary="Acessar Home Comum" />
            </ListItem>
            <ListItem
              button
              onClick={() => navigate("/estatisticas")}
              sx={{
                transition:
                  "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.07)",
                  transform: "scale(1.05)",
                },
              }}
            >
              <ListItemIcon>
                <BarChartIcon />
              </ListItemIcon>
              <ListItemText primary="Estatísticas" />
            </ListItem>
            <ListItem
              button
              onClick={handleOpenConfigMenu}
              sx={{
                transition:
                  "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.07)",
                  transform: "scale(1.05)",
                },
              }}
            >
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Configurações" />
            </ListItem>
            <Menu
              anchorEl={anchorElConfig}
              keepMounted
              open={Boolean(anchorElConfig)}
              onClose={handleCloseMenus}
              sx={{
                "& .MuiPaper-root": {
                  animation: "fadeIn 0.3s ease-in-out",
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate("/servicos/cadastrar");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <AddIcon /> Cadastrar Serviço
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/servicos/gerenciar/CONSULTA");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <ListIcon /> Gerenciar Tipos
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/ubs/listar");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <ListAltIcon /> Listar UBS
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/ubs/cadastrar");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <LocalHospitalIcon /> Cadastrar UBS
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/atualizar-senha-usuario");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <LockResetIcon /> Atualizar senha de Usuário
              </MenuItem>
            </Menu>
          </>
        )}
        <ListItem
          button
          aria-label="Menu do usuário"
          aria-controls="menu-usuario"
          aria-haspopup="true"
          aria-expanded={Boolean(anchorElUser) ? "true" : "false"}
          onClick={handleOpenUserMenu}
          sx={{
            transition:
              "background 0.3s ease-in-out, transform 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.07)",
              transform: "scale(1.05)",
            },
          }}
        >
          <ListItemIcon>
            <AccountCircleIcon />
          </ListItemIcon>
          <Typography variant="body1" style={{ marginLeft: 8 }}>
            {username ? username.split(" ").slice(0, 2).join(" ") : "Sem Nome"}
          </Typography>
        </ListItem>
        <Menu
          anchorEl={anchorElUser}
          keepMounted
          open={Boolean(anchorElUser)}
          onClose={handleCloseMenus}
          sx={{
            "& .MuiPaper-root": {
              animation: "fadeIn 0.3s ease-in-out",
            },
          }}
        >
          <MenuItem
            onClick={() => {
              navigate("/atualizar-senha");
              handleCloseMenus();
            }}
            sx={{
              transition:
                "background 0.3s ease-in-out, transform 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.07)",
                transform: "scale(1.05)",
              },
            }}
          >
            Atualizar Senha
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate("/atualizar-cadastro");
              handleCloseMenus();
            }}
            sx={{
              transition:
                "background 0.3s ease-in-out, transform 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.07)",
                transform: "scale(1.05)",
              },
            }}
          >
            Atualizar Cadastro
          </MenuItem>
          {role === "ROLE_SECRETARIA" && (
            <MenuItem
              onClick={() => navigate("/auditoria")}
              sx={{
                transition:
                  "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.07)",
                  transform: "scale(1.05)",
                },
              }}
            >
              Auditoria
            </MenuItem>
          )}
          <MenuItem
            onClick={handleLogout}
            sx={{
              transition:
                "background 0.3s ease-in-out, transform 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.07)",
                transform: "scale(1.05)",
              },
            }}
          >
            Sair
          </MenuItem>
        </Menu>
      </List>
    </Drawer>
  );

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: isUserParamPresent ? "warning.main" : "primary.main",
      }}
    >
      <Toolbar>
        {isMobile && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="Abrir menu de navegação"
            aria-haspopup="true"
            aria-expanded={isMobileMenuOpen ? "true" : "false"}
            onClick={toggleMobileMenu}
          >
            <MenuIcon />
          </IconButton>
        )}
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            justifyContent: isMobile ? "center" : "flex-start",
            alignItems: "center",
            padding: isMobile ? "5px" : "0",
          }}
        >
          <img
            src="/logo_retangular.png"
            alt="Conecta Vicência"
            width={isMobile ? "100" : "120"}
            style={{
              cursor: "pointer",
              backgroundColor: "white",
              padding: isMobile ? "5px" : "10px",
              borderRadius: "8px",
              marginLeft: isMobile ? "-40px" : "0"
            }}
            onClick={handleHomeNavigation}
          />
        </div>

        {!isMobile && (
          <>
            <IconButton color="inherit" onClick={handleHomeNavigation}>
              <HomeIcon />
                <Typography variant="body1" style={{ marginLeft: 8 }}>
                  Home
                </Typography>
              </IconButton>
              {role === "ROLE_SECRETARIA" && (
                <>
                <IconButton
                  color="inherit"
                  onClick={() => navigate("/home")}
                >
                  <HomeIcon />
                  <Typography variant="body1" style={{ marginLeft: 8 }}>
                    Acessar Home Comum
                  </Typography>
                </IconButton>
                <IconButton
                  color="inherit"
                  onClick={() => navigate("/estatisticas")}
                >
                  <BarChartIcon />
                  <Typography variant="body1" style={{ marginLeft: 8 }}>
                    Estatísticas
                  </Typography>
                </IconButton>
                <IconButton color="inherit" onClick={handleOpenConfigMenu}>
                  <SettingsIcon />
                  <Typography variant="body1" style={{ marginLeft: 8 }}>
                    Configurações
                  </Typography>
                </IconButton>
                <Menu
                  anchorEl={anchorElConfig}
                  keepMounted
                  open={Boolean(anchorElConfig)}
                  onClose={handleCloseMenus}
                  sx={{
                    "& .MuiPaper-root": {
                      animation: "fadeIn 0.3s ease-in-out",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      navigate("/servicos/cadastrar");
                      handleCloseMenus();
                    }}
                    sx={{
                      transition:
                        "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.07)",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <AddIcon /> Cadastrar Serviço
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/servicos/gerenciar/CONSULTA");
                      handleCloseMenus();
                    }}
                    sx={{
                      transition:
                        "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.07)",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <ListIcon /> Gerenciar Tipos
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/ubs/listar");
                      handleCloseMenus();
                    }}
                    sx={{
                      transition:
                        "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.07)",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <ListAltIcon /> Listar UBS
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/ubs/cadastrar");
                      handleCloseMenus();
                    }}
                    sx={{
                      transition:
                        "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.07)",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <LocalHospitalIcon /> Cadastrar UBS
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      navigate("/atualizar-senha-usuario");
                      handleCloseMenus();
                    }}
                    sx={{
                      transition:
                        "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.07)",
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <LockResetIcon /> Atualizar senha de Usuário
                  </MenuItem>
                </Menu>
              </>
            )}
            <IconButton color="inherit" onClick={handleOpenUserMenu}>
              <AccountCircleIcon />
              <Typography variant="body1" style={{ marginLeft: 8 }}>
                {username
                  ? username.split(" ").slice(0, 2).join(" ")
                  : "Sem Nome"}
              </Typography>
            </IconButton>
            <Menu
              anchorEl={anchorElUser}
              keepMounted
              open={Boolean(anchorElUser)}
              onClose={handleCloseMenus}
              sx={{
                "& .MuiPaper-root": {
                  animation: "fadeIn 0.3s ease-in-out",
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  navigate("/atualizar-senha");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                Atualizar Senha
              </MenuItem>
              <MenuItem
                onClick={() => {
                  navigate("/atualizar-cadastro");
                  handleCloseMenus();
                }}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                Atualizar Cadastro
              </MenuItem>
              {role === "ROLE_SECRETARIA" && (
                <MenuItem
                  onClick={() => navigate("/auditoria")}
                  sx={{
                    transition:
                      "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.07)",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  Auditoria
                </MenuItem>
              )}
              <MenuItem
                onClick={handleLogout}
                sx={{
                  transition:
                    "background 0.3s ease-in-out, transform 0.2s ease-in-out",
                  "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, 0.07)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                Sair
              </MenuItem>
            </Menu>
          </>
        )}
      </Toolbar>
      {isMobile && mobileMenu}
    </AppBar>
  );
};

export default Navbar;
